import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = { class: "w-full p-7" };
var _hoisted_2 = { key: 0 };
var _hoisted_3 = { class: "mb-7 text-3xl text-center font-bold" };
var _hoisted_4 = { class: "mt-7 flex flex-col gap-y-4" };
var _hoisted_5 = { class: "font-bold" };
var _hoisted_6 = { class: "ml-4 font-bold" };
var _hoisted_7 = {
    key: 1,
    class: "flex flex-col items-center"
};
var _hoisted_8 = { class: "mb-5 text-3xl text-center font-bold" };
var _hoisted_9 = { class: "mb-10 text-center font-medium text-gray/80 max-w-80" };
var _hoisted_10 = { class: "font-bold" };
var _hoisted_11 = { class: "font-bold" };
import { useI18n } from 'vue-i18n';
import { apiErrorsHandle, openLink } from '@common/utils/Helpers/Helpers';
import { AuthModalStore } from '@student/modules/store';
import Api from '@student/modules/api/api';
import { useForm, useIsFormDirty, useIsFormValid } from 'vee-validate';
import { toTypedSchema } from '@vee-validate/zod';
import { computed, ref, watch } from 'vue';
import EInputField from '@common/ui/EForm/fields/EInputField.vue';
import EButton from '@common/ui/EButton.vue';
import { z } from 'zod';
import ELabel from '@common/ui/ELabel.vue';
import EIcon from '@common/ui/EIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AuthModalPasswordRecovery',
    setup: function (__props) {
        var t = useI18n().t;
        var loading = ref(false);
        var success = ref(false);
        var _a = useForm({
            validationSchema: toTypedSchema(z.object({
                email: z.string()
                    .min(1, t('passwordRecovery.validation.required'))
                    .email({ message: t('passwordRecovery.validation.invalidEmail') })
            })),
            keepValuesOnUnmount: true
        }), values = _a.values, setValues = _a.setValues, resetForm = _a.resetForm, handleSubmit = _a.handleSubmit;
        var isValid = useIsFormValid();
        var isDirty = useIsFormDirty();
        var loginEmail = computed(function () { return AuthModalStore.email; });
        watch(loginEmail, function (email) {
            setValues({
                email: email
            });
        });
        var submitForm = handleSubmit(function (values, ctx) {
            loading.value = true;
            Api.recoverPassword(values.email)
                .then(function (res) {
                var result = res.data;
                loading.value = false;
                success.value = true;
            })
                .catch(function (err) {
                loading.value = false;
                apiErrorsHandle(err, {
                    'USER_NOT_FOUND': t('passwordRecovery.errors.userNotFound'),
                    'INVALID_EMAIL': t('passwordRecovery.errors.invalidEmail')
                });
            });
        });
        var closeRecovery = function () {
            AuthModalStore.goLogin();
        };
        var mailDomains = [
            'gmail.com',
            'yahoo.com',
            'outlook.com',
            'yandex.ru',
            'yandex.com',
            'mail.com',
            'mail.ru',
        ];
        var mailDomain = computed(function () { var _a; return (_a = values.email) === null || _a === void 0 ? void 0 : _a.split('@')[1]; });
        var isShowEmailButton = computed(function () { return mailDomain.value && mailDomains.includes(mailDomain.value); });
        var goToMailbox = function () {
            openLink("https://".concat(mailDomain.value));
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (!success.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("h4", _hoisted_3, _toDisplayString(_unref(t)('passwordRecovery.title')), 1),
                        _createVNode(ELabel, {
                            label: _unref(t)('passwordRecovery.emailLabel'),
                            weight: "medium"
                        }, {
                            default: _withCtx(function () { return [
                                _createVNode(EInputField, {
                                    placeholder: _unref(t)('passwordRecovery.emailPlaceholder'),
                                    plugins: ['trim'],
                                    name: "email",
                                    size: "large",
                                    theme: "gray",
                                    type: "email",
                                    autocomplete: "",
                                    autofocus: "",
                                    onKeyup: _withKeys(_unref(submitForm), ["enter"])
                                }, null, 8, ["placeholder", "onKeyup"])
                            ]; }),
                            _: 1
                        }, 8, ["label"]),
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(EButton, {
                                disabled: !_unref(isValid) || !_unref(isDirty),
                                loading: loading.value,
                                size: "large",
                                type: "primary",
                                onClick: _unref(submitForm)
                            }, {
                                default: _withCtx(function () { return [
                                    _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('passwordRecovery.sendButton')), 1)
                                ]; }),
                                _: 1
                            }, 8, ["disabled", "loading", "onClick"]),
                            _createVNode(EButton, {
                                size: "large",
                                type: "secondary",
                                onClick: closeRecovery
                            }, {
                                default: _withCtx(function () { return [
                                    _createVNode(EIcon, {
                                        class: "w-3 h-2.5 opacity-50",
                                        icon: "arrow-left"
                                    }),
                                    _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)('passwordRecovery.backButton')), 1)
                                ]; }),
                                _: 1
                            })
                        ])
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(EIcon, {
                            class: "mb-7 w-12 h-12 text-green",
                            icon: "envelope-dot"
                        }),
                        _createElementVNode("h4", _hoisted_8, _toDisplayString(_unref(t)('passwordRecovery.successTitle')), 1),
                        _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(t)('passwordRecovery.successMessage')), 1),
                        (isShowEmailButton.value)
                            ? (_openBlock(), _createBlock(EButton, {
                                key: 0,
                                class: "w-full",
                                size: "large",
                                type: "primary",
                                onClick: goToMailbox
                            }, {
                                default: _withCtx(function () { return [
                                    _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)('passwordRecovery.goToMail')), 1),
                                    _createVNode(EIcon, {
                                        class: "ml-2 w-4 h-4 opacity-50",
                                        icon: "redirect-square"
                                    })
                                ]; }),
                                _: 1
                            }))
                            : (_openBlock(), _createBlock(EButton, {
                                key: 1,
                                class: "w-full",
                                size: "large",
                                type: "primary",
                                onClick: closeRecovery
                            }, {
                                default: _withCtx(function () { return [
                                    _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(t)('passwordRecovery.okButton')), 1)
                                ]; }),
                                _: 1
                            }))
                    ]))
            ]));
        };
    }
});
